import { Box, Typography, Modal, Button } from "@mui/material";

import { AlertBar } from "../../../../components";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useMutation } from "@tanstack/react-query";
import { LoadingButton } from "@mui/lab";
import { bypassRebootOnline, sendCommandControl } from "../../../../services/apis";
import { selectUserEmail } from "../../../../redux/Slice/Authentication/AuthenticationSlice";

const getModalStyle = () => ({
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 404,
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: 24,
  p: 4,
  maxHeight: "95vh",
  overflowY: "auto",
});

export default function BypassUnitModel({
  openBypassUnitModel,
  setOpenBypassUnitModel,
  setValue,
  unit,
  setAlertState
}: any) {
  const userEmail = useSelector(selectUserEmail);
  const handleClose = () => {
    setValue('offline');
    setIsLoading(false);
    setOpenBypassUnitModel(false)
  };
  const [showAlert, setShowAlert] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const bypassMutation = useMutation<number, Error, { control: string; units: string[] }>({
    mutationFn: ({ control, units }) => sendCommandControl(control, units),
    onSuccess: () => {
      setIsLoading(false);
      handleClose();
      setAlertState({
        isAlert: true,
        severity: "info",
        title: "",
        description: "PACE AI device on selected unit is waiting to be bypassed.",
        resetOpen: true,
      });
    },
    onError: (error) => {
      setIsLoading(false);
      handleClose();
      setAlertState({
        isAlert: true,
        severity: "error",
        title: "",
        description: "Failed to take bypass PACE AI device on selected unit. Please try again later.",
        resetOpen: true,
      });
    },
  });


  const handleSendCommand = () => {
    const serialNums: string[] = [unit?.pace_device_serial_number];
    setIsLoading(true);
    bypassMutation.mutate({ control: "bypass", units: serialNums });
  };

  return (
    <Modal
      open={openBypassUnitModel}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={getModalStyle}>
        <Typography id="modal-modal-title" variant="h6">
          Bypass unit
        </Typography>
        <Box sx={{ marginTop: "20px" }} />
        <AlertBar
          severity={"warning"}
          title={"Warning:"}
          description={
            "This action will override the settings for the selected unit, making the HVAC unit operate as if a PACE AI device is not installed. The user will be responsible for lost energy savings."
          }
          variant={"standard"}
          show={showAlert}
          setShow={setShowAlert}
        />
        <Box sx={{ marginTop: "20px" }} />
        <Typography id="modal-modal-title" variant="body1">
          Please review your selection carefully before proceeding:
        </Typography>
        <Box sx={{ marginTop: "20px" }} />
        <Typography id="modal-modal-title" variant="body1">
          {`1. Unit: ${unit?.unit_name || ""}`}
        </Typography>
        <Typography id="modal-modal-title" variant="body1">
          {`2. PACE device: ${unit?.pace_ai_device_id || ""}`}
        </Typography>
        <Box sx={{ marginTop: "20px" }} />
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
          <Button
            variant="text"
            color="primary"
            size="medium"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <LoadingButton
            loading={isLoading}
            variant="contained"
            size="medium"
            onClick={handleSendCommand}
          >
            bypass units
          </LoadingButton>
        </Box>
      </Box>
    </Modal>
  );
}
